import type { FunctionComponent } from 'react'
import React, { forwardRef } from 'react'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Dropdown } from 'react-bootstrap'
import type { BusyButtonProps } from '@ztechapps/webui.button'
import { BusyButtonLink } from '@ztechapps/webui.button'

export type TableRowActionProps = {
  showQuickActions: boolean
  firstQuickAction: React.ReactNode
  secondQuickAction?: React.ReactNode
  thirdQuickAction?: React.ReactNode
  children?: React.ReactNode
  components?: {
    TableActionButtonsCell?: FunctionComponent<TableActionButtonsCellProps>
  }
}
export const TableRowAction = ({
  showQuickActions,
  firstQuickAction,
  secondQuickAction,
  thirdQuickAction,
  children,
  components,
}: TableRowActionProps) => {
  const ActionButtonsCell = components?.TableActionButtonsCell ?? TableActionButtonsCell

  return (
    <ActionButtonsCell>
      <HorizontalStack gap={1} className="justify-content-end">
        <HorizontalStack gap={1} style={{ visibility: showQuickActions ? 'visible' : 'hidden' }}>
          {firstQuickAction}
          {secondQuickAction}
          {thirdQuickAction}
        </HorizontalStack>
        <ShowIf condition={!!children}>
          <Dropdown align="end">
            <Dropdown.Toggle
              id="more-actions-toggle"
              as={LinkDropdownToggle}
              icon="ellipsis-v"
              title="Show more actions..."
              aria-label="Show more actions..."
            />
            <Dropdown.Menu>{children}</Dropdown.Menu>
          </Dropdown>
        </ShowIf>
      </HorizontalStack>
    </ActionButtonsCell>
  )
}

export type LinkDropdownToggleProps = Pick<
  BusyButtonProps,
  'icon' | 'title' | 'bsStyle' | 'aria-label' | 'children'
> & { onClick: (event: React.MouseEvent) => void; id?: string }

// Dropdown.Toggle hands its `as` the dropdown-toggle class that draws the caret —
// every prop is picked by name so that class never reaches the DOM.
export const LinkDropdownToggle = forwardRef<HTMLDivElement, LinkDropdownToggleProps>(
  ({ onClick, id, icon, title, bsStyle, 'aria-label': ariaLabel, children }, ref) => (
    <div ref={ref} id={id}>
      <BusyButtonLink icon={icon} title={title} bsStyle={bsStyle} aria-label={ariaLabel} onClick={onClick}>
        {children}
      </BusyButtonLink>
    </div>
  )
)

export type TableActionButtonsCellProps = {
  children: React.ReactNode
}
export const TableActionButtonsCell = ({ children }: { children: React.ReactNode }) => {
  return (
    <td className="text-end " style={{ width: '30px' }}>
      {children}
    </td>
  )
}
